import { EVIDENCE_ENFORCEMENT_LABELS, EvidenceCollectionConfig, EvidenceEnforcement, resolveEvidenceConfig, TaskEvidenceKind, TaskEvidenceOptions } from '@jms/model';

export interface EvidenceEnforcementOption {
  value: EvidenceEnforcement;
  label: string;
  description: string;
}

const EVIDENCE_ENFORCEMENT_DESCRIPTIONS: Record<EvidenceEnforcement, string> = {
  [EvidenceEnforcement.Optional]: 'Never blocks the task',
  [EvidenceEnforcement.RequiredExceptionAllowed]: 'Evidence or a recorded exception before the task completes',
  [EvidenceEnforcement.RequiredNoExceptions]: 'Evidence only; the way out is Cannot Complete',
};

/** Ladder order, not alphabetical, so the list reads from weakest to strictest. */
export const EVIDENCE_ENFORCEMENT_OPTIONS: readonly EvidenceEnforcementOption[] = Object
  .values(EvidenceEnforcement)
  .map(level => ({ value: level, label: EVIDENCE_ENFORCEMENT_LABELS[level], description: EVIDENCE_ENFORCEMENT_DESCRIPTIONS[level] }));

export const EVIDENCE_COLLECTION_LABELS: Record<TaskEvidenceKind, string> = {
  beforePhoto: 'Before photos',
  duringPhoto: 'During photos',
  afterPhoto: 'After photos',
  form: 'Form',
  file: 'Files',
  signature: 'Signature',
  comment: 'Comment',
};

/** One wording for every read-only place a collection and its level appear together. */
export function evidenceLevelLabel(config: EvidenceCollectionConfig): string {

  return `${EVIDENCE_COLLECTION_LABELS[config.kind]} · ${EVIDENCE_ENFORCEMENT_LABELS[config.enforcement]}`;
}

/** Every enabled collection with its level, so a board tooltip never hides the stricter of two photo collections. */
export function evidenceLevelsSummary(options: TaskEvidenceOptions): string {

  return resolveEvidenceConfig(options).map(evidenceLevelLabel).join(', ');
}
